const revealBlocks = document.querySelectorAll('[data-reveal-group]');

if (revealBlocks.length && 'IntersectionObserver' in window) {
  document.documentElement.classList.add('reveal-animations-ready');

  const myObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      const revealBlock = entry.target.closest('[data-reveal-group]');

      if(!revealBlock){
        return;
      }

      if(entry.isIntersecting) {
        revealBlock.classList.add('is-visible_denau');
      } else {
        revealBlock.classList.remove('is-visible_denau');
      }

    });
  });

  revealBlocks.forEach(function(revealBlock) {
    const heading = revealBlock.querySelector('[data-reveal-heading]');

    if(!heading) {
      return;
    }

    myObserver.observe(heading);
  });
}